import { Brand } from "@/types/brand";

const brandsData: Brand[] = [
  {
    id: 1,
    name: "Akamai",
    href: "https://www.akamai.com",
    image: "/images/brands/Akamai.png",
    imageLight: "/images/brands/Akamai.png",
  },
  {
    id: 2,
    name: "CME Group",
    href: "https://www.cmegroup.com",
    image: "/images/brands/CME_Group-Logo.wine.png",
    imageLight: "/images/brands/CME_Group-Logo.wine.png",
  },
  {
    id: 3,
    name: "BpiFrance",
    href: "https://bpifrance.fr",
    image: "/images/brands/bpifrance.svg",
    imageLight: "/images/brands/bpifrance-light.svg",
  }
];

export default brandsData;
